export const environment = {
  production: false,
  portal_url: 'https://dev-v1.africaweather.com/'
};